import { useQuery } from "@tanstack/react-query";
import { useI18n } from "@wato/i18n/react";
import { DismissibleBanner } from "@wato/ui";
import { useApi } from "../../api/context";
import { SHELL_STALE_MS } from "../../api/query-client";

/**
 * OWN-150j: platform announcement banners (created in the admin app, served per workspace by
 * `GET /v1/announcements`). One line each, queued by the shell's `BannerSlot`; dismissals are
 * remembered in this browser (G10).
 */
export function AnnouncementBanners({ workspaceId }: { readonly workspaceId: string }) {
  const { locale } = useI18n();
  const api = useApi();
  const query = useQuery({
    queryKey: ["announcements", workspaceId],
    staleTime: SHELL_STALE_MS,
    refetchInterval: 10 * 60_000,
    queryFn: () => api.listAnnouncements(workspaceId),
  });
  return (
    <>
      {(query.data ?? []).map((b) => (
        <DismissibleBanner
          key={b.id}
          id={`announcement-${b.id}`}
          priority={30}
          testId="announcement-banners"
        >
          {b.content[locale === "ar" ? "ar" : "en"]}
        </DismissibleBanner>
      ))}
    </>
  );
}
